// eslint-disable-next-line
import FormValidation from "../../validations/es6/core/Core";
import axios from "axios";
import Trigger from "../../validations/es6/plugins/Trigger";
import Bootstrap from "../../validations/es6/plugins/Bootstrap";
import SubmitButton from "../../validations/es6/plugins/SubmitButton";
import Declarative from "../../validations/es6/plugins/Declarative";
import { getCookie } from "../../jwt/_helpers/cookie";
import { getValidationMessage } from "../../utils/i18nHelper";

import labelsValidationEN from "../../locales/en/labelsValidation";
import labelsValidationDE from "../../locales/de/labelsValidation";
import labelsValidationES from "../../locales/es/labelsValidation";
import labelsValidationFR from "../../locales/fr/labelsValidation";
import labelsValidationIT from "../../locales/it/labelsValidation";
import labelsValidationHR from "../../locales/hr/labelsValidation";
import labelsValidationNL from "../../locales/nl/labelsValidation";
import labelsValidationPT from "../../locales/pt/labelsValidation";

const API_URL = process.env.REACT_APP_API_URL_BASE;
const X_API_KEY = process.env.REACT_APP_X_API_KEY;

export const validationMessages = {
  en: labelsValidationEN,
  de: labelsValidationDE,
  es: labelsValidationES,
  fr: labelsValidationFR,
  it: labelsValidationIT,
  hr: labelsValidationHR,
  nl: labelsValidationNL,
  pt: labelsValidationPT,
};

const createValidationOptions = (lang) => {
  return {
    fields: {
      name: {
        validators: {
          notEmpty: {
            message: getValidationMessage(validationMessages, 'name', 'required', lang)
          },
          promise: {
            message: getValidationMessage(validationMessages, 'name', 'unique', lang),
            promise: function(input) {
              return new Promise(function(resolve, reject) {
                if(input.value !== "") {
                  const token = getCookie("token");
                  const requestBody = {
                    label_name: input.value,
                  };
                  axios({
                    method: "POST",
                    mode: 'cors',
                    url: `${API_URL}labels/validate-label-name/`,
                    data: requestBody,
                    headers: {
                      Authorization: `Bearer ${token}`,
                      "x-api-key": X_API_KEY,
                    }
                  }).then(function(response) {
                    if (response.status === 200) {
                      const valid = response.data.valid;
                      const message = response.data.status;
  
                      valid ? resolve({ valid: true, message: getValidationMessage(validationMessages, 'name', 'available', lang) }) : resolve({ valid: false, message: message });
                    } else {
                      reject({valid: false, message: getValidationMessage(validationMessages, 'name', 'invalid', lang)});
                    }
                  });
                }
              });
            }
          },
        }
      },
      year: {
        validators: {
          notEmpty: {
            message: getValidationMessage(validationMessages, 'year', 'required', lang)
          },
          numeric: {
            message: getValidationMessage(validationMessages, 'year', 'numeric', lang),
          },
          stringLength: {
            min: 4,
            max: 4,
            message: getValidationMessage(validationMessages, 'year', 'stringLength', lang),
          },
        }
      },
      releaseCatalog: {
        validators: {
          notEmpty: {
            message: getValidationMessage(validationMessages, 'releaseCatalog', 'required', lang)
          },
          numeric: {
            message: getValidationMessage(validationMessages, 'releaseCatalog', 'numeric', lang),
          }
        }
      },
      logo: {
        validators: {
          notEmpty: {
            message: getValidationMessage(validationMessages, 'logo', 'required', lang)
          },
          promise: {
            promise: function(input) {
              return new Promise(function(resolve, reject) {
                const files = input.element.files;
  
                const img = new Image();
                img.addEventListener("load", function() {
                  const w = this.width;
                  const h = this.height;
                  resolve({
                    valid: w === 1000 && h === 1000,
                    message: getValidationMessage(validationMessages, 'logo', 'dimensions', lang),
                    meta: {
                      source: img.src,
                      width: w,
                      height: h
                    }
                  });
                });
                img.addEventListener("error", function() {
                  reject({
                    valid: false,
                    message: getValidationMessage(validationMessages, 'logo', 'choose', lang)
                  });
                });
  
                const reader = new FileReader();
                reader.readAsDataURL(files[0]);
                reader.addEventListener("loadend", function(e) {
                  img.src = e.target.result;
                });
              });
            }
          },
          file: {
            extension: "jpeg,jpg,png",
            type: "image/jpeg,image/png",
            maxSize: 2048576,
            message: getValidationMessage(validationMessages, 'logo', 'file', lang)
          }
        }
      },
      promo_graphic: {
        validators: {
          promise: {
            promise: function(input) {
              return new Promise(function(resolve, reject) {
                const files = input.element.files;
                // if (
                //   !files.length ||
                //   typeof FileReader === "undefined" ||
                //   files[0].type !== "image/jpeg"|| files[0].type !== "image/png"
                // ) {
                //   resolve({
                //     valid: true
                //   });
                // }
  
                const img = new Image();
                img.addEventListener("load", function() {
                  const w = this.width;
                  const h = this.height;
  
                  resolve({
                    valid: w === 960 && h === 150,
                    message: getValidationMessage(validationMessages, 'promo_graphic', 'dimensions', lang),
                    meta: {
                      source: img.src,
                      width: w,
                      height: h
                    }
                  });
                });
                img.addEventListener("error", function() {
                  reject({
                    valid: false,
                    message: getValidationMessage(validationMessages, 'promo_graphic', 'choose', lang)
                  });
                });
  
                const reader = new FileReader();
                reader.readAsDataURL(files[0]);
                reader.addEventListener("loadend", function(e) {
                  img.src = e.target.result;
                });
              });
            }
          },
          file: {
            extension: "jpeg,jpg,png",
            type: "image/jpeg,image/png",
            maxSize: 100000,
            message: getValidationMessage(validationMessages, 'promo_graphic', 'file', lang)
          }
        }
      },
    },
    plugins: {
      trigger: new Trigger(),
      bootstrap: new Bootstrap(),
      submitButton: new SubmitButton(),
      declarative: new Declarative({
        html5Input: true
      })
    }
  };
};

export { createValidationOptions };